import { createRouter, createWebHistory} from 'vue-router'
import SearchEntry from "@/views/SearchEntry";
import APIInfo from "@/views/APIInfo";
// import BatchSeach from "@/views/BatchSeach";

const routes = [
    // {
    //     path:"/",
    //     name:'BatchSearch',
    //     component: BatchSeach
    // },
    {
        path:"/",
        name:'Search',
        component: SearchEntry
    },
    {
        path:"/api_v1",
        name:'API Documentation',
        component: APIInfo
    }
]

const router = createRouter({
    history:createWebHistory(process.env.BASE_URL),
    routes
})

export default router